export default __webpack_public_path__ + "static/media/bg11.0c10d7ff.jpg";